import  { useCallback, useMemo, useState, useEffect } from "react";
import { Box } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useStateContext } from "@durlabh/dframework-ui";
import Navigation from "./Navigation";
import TopHeader from "./TopHeader";

function Layout({ userData }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { dispatchData } = useStateContext();

  const [drawerOpen, setDrawerOpen] = useState(true);
  const [menuData, setMenuData] = useState([]);
  const toggleDrawer = useCallback(() => setDrawerOpen((prev) => !prev), []);
  const wrapperClass = useMemo(
    () =>
      `${location.pathname} main-wrapper ${drawerOpen ? "drawer-open" : ""}`,
    [location.pathname, drawerOpen]
  );
  useEffect(() => {
    const { permissions, userDetails, menuDetails } = userData;
    setMenuData(menuDetails);
    dispatchData({ type: "USER_DATA", payload: { permissions, menuDetails, userDetails, drawerOpen } });
    if (location.pathname === "/") {
      navigate("/dashboard");
    }
  }, [userData, drawerOpen]);
  return (
    <Box>
      <TopHeader user={userData.userDetails} />
      <Navigation
        drawerOpen={drawerOpen}
        onToggleDrawer={toggleDrawer}
        menuData={menuData}
        user={userData.userDetails}
      />
      <Box
        className={wrapperClass}
        sx={{ padding: 1, paddingTop: 5 }}
        id="main-page-wrapper"
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default Layout;